/* eslint-disable no-unused-vars */
import { cloneDeep } from 'lodash';
import { numberOfAccessPoints } from '../businessWifi/businessWifiFieldNames';
import { addProductVulcan } from '../customerInformation/customerInformationFieldNames';
// import { fibreSpeed, offers } from '../fibeInternet/fibreInternetFieldNames';
import {
  mobilityMonthlyCharge,
  mobilityOneTimeCharge
} from '../mobility/mobilityFieldNames';
import {
  secureBusinessOffersVulcan,
  secureBusinessPlan
} from '../secureBusiness/secureBusinessFieldNames';

import {
  keyControlIncludedEquipmentVulcan,
  keyProtectIncludedEquipmentVulcan,
  keyMonitorIncludedEquipmentVulcan,
  keyControlIncludedEquipmentCameraSelectionVulcan,
  keyMonitorAdditionalEquipmentVulcan,
  keyProtectAdditionalEquipmentVulcan,
  keyControlAdditionalEquipmentVulcan,
  keyProtectIncludedEquipmentCameraSelectionVulcan,
  isCouponBasedDiscountField,
  isCouponBasedDiscountTSBField,
  smartCameraIncludedEquipmentCameraSelectionVulcan,
  smartCameraAdditionalEquipmentVulcan,
  tsbTerm,
  termVulcan,
  existingEquipmentVulcan,
  tsb15SectionPriceKeys,
  fieldInstallationFeeAmount
} from '../../../utils/constant';

import { getFieldValue } from '../../utils';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import { getSummaryDetailsForFieldWithProductCatalog } from './getFieldSummaryDetails';
import { fieldNameOfferIBVulcan } from '../telusBusinessInternetBackup/telusBusinessInternetBackupFieldName';
import { getOfferDescription } from './utils';

export const GET_FIELD_VALUE = 'GET_FIELD_VALUE';

const getLocalizedConfig = (locale, forceOpposite) => {
  const isEnglish = locale === 'en-US';
  return (forceOpposite ? !isEnglish : isEnglish) ? FR : EN;
};

const getSummaryConfig = alternateLanguage => {
  const locale = getLocale();

  const {
    vulcanWebform: {
      yes,
      vulMonitorTSB,
      vulControlTSB,
      vulSmartCameraTSB,
      vulProtectTSB,
      vulMobility,
      vulTSB,
      vulSixtyMonth,
      vulThirtyMonth,
      vulFibreInternet,
      vulCopperInternet,
      vulBusinessWifi,
      vulBusinessOptikTV,
      vulOfficePhone,
      vulInternetBackup,
      vulFibreOpticDrop,
      summaryConfig: {
        speedLabel,
        offersLabel,
        devicesLabel,
        planLabel,
        includedLabel,
        additionalAccessPointsLabel,
        additionalEquipmentsFiveYearLabel,
        additionalEquipmentsOneTimeLabel,
        additionalEquipmentsThreeYearLabel,
        additionalEquipmentsMonthlyRecuringLabel,
        installationTSBLabel,
        installationFee,
        termLabel,
        priceLockOffersLabel,
        addOnTakeoverEquipmentOneTimePayment,
        addOnTakeoverEquipmentThreeYear,
        addOnTakeoverEquipmentFiveYear
      }
    }
  } = getLocalizedConfig(locale, !alternateLanguage);

  const includedEquipmentValuesMap = {
    [vulMonitorTSB]: [keyMonitorIncludedEquipmentVulcan],
    [vulProtectTSB]: [
      keyProtectIncludedEquipmentVulcan,
      keyProtectIncludedEquipmentCameraSelectionVulcan
    ],
    [vulControlTSB]: [
      keyControlIncludedEquipmentVulcan,
      keyControlIncludedEquipmentCameraSelectionVulcan
    ],
    [vulSmartCameraTSB]: [smartCameraIncludedEquipmentCameraSelectionVulcan]
  };

  const additionalEquipmentValuesMap = {
    [vulMonitorTSB]: [keyMonitorAdditionalEquipmentVulcan],
    [vulProtectTSB]: [keyProtectAdditionalEquipmentVulcan],
    [vulControlTSB]: [keyControlAdditionalEquipmentVulcan],
    [vulSmartCameraTSB]: [smartCameraAdditionalEquipmentVulcan]
  };

  return [
    // {
    //   sectionTitle: 'Fibre Internet',
    //   shouldShowSection: formFields => {
    //     return getFieldValue(addProductVulcan, formFields).includes(
    //       vulFibreInternet
    //     );
    //   },
    //   rows: [
    //     {
    //       label: speedLabel,
    //       description: GET_FIELD_VALUE,
    //       checkForKey: fibreSpeed
    //     },
    //     {
    //   label: priceLockOffersLabel,
    //   listSelectedOptionsForKey: offers,
    //   getCustomLabel: formField => {
    //     const updatedFormField = cloneDeep(formField);
    //     if (updatedFormField[offers].value) {
    //       updatedFormField[offers].value = updatedFormField[
    //         offers
    //       ].value.map(discount => discount.replace(/\s\((BTL|ATL)\)/g, '')
    //           .replace(/\s\((?:ATL\s*&\s*BTL|BTL\s*&\s*ATL)\)/g, ''));
    //       updatedFormField[offers].options = updatedFormField[
    //         offers
    //       ].options.map(option => {
    //         const updatedOption = { ...option };
    //         if (updatedOption.fields.value) {
    //           updatedOption.fields.value = updatedOption.fields.value
    //             .replace(/\s\((BTL|ATL)\)/g, '')
    //             .replace(/\s\((?:ATL\s*&\s*BTL|BTL\s*&\s*ATL)\)/g, ''
    //           );
    //         }
    //         return updatedOption;
    //       });
    //     }
    //     return updatedFormField[offers];
    //   }
    // },
    //     {
    //       label: 'Installation',
    //       listSelectedOptionsForKey: 'fibreInstallation'
    //     }
    //   ]
    // },
    {
      sectionTitle: 'Fibre Internet',
      shouldShowSection: formFields => {
        const value = getFieldValue(addProductVulcan, formFields);
        return value && value.includes(vulFibreInternet);
      },
      rows: [
        {
          label: 'fibreInternetData',
          listSelectedOptionsProductCatalog: 'fibreInternetData'
        }
      ],
      isFlattenedRows: true
    },
    {
      sectionTitle: 'Copper Internet',
      shouldShowSection: formFields => {
        const value = getFieldValue(addProductVulcan, formFields);
        return value && value.includes(vulCopperInternet);
      },
      rows: [
        {
          label: 'CopperInternetData',
          listSelectedOptionsProductCatalog: 'copperInternetData'
        }
      ],
      isFlattenedRows: true
    },
    {
      sectionTitle: 'Business Wifi',
      shouldShowSection: formFields => {
        const value = getFieldValue(addProductVulcan, formFields);
        return value && value.includes(vulBusinessWifi);
      },
      rows: [
        {
          label: devicesLabel,
          description: 'MR28',
          checkForKey: addProductVulcan,
          checkForOption: vulBusinessWifi
        },
        {
          label: additionalAccessPointsLabel,
          checkForKey: numberOfAccessPoints,
          transformer: value => {
            const qty = +(value.qty || 0);
            const monthlyChargesPerUnit = value.monthlyCharges / qty;
            return {
              ...value,
              qty: qty - 1,
              monthlyCharges: monthlyChargesPerUnit * (qty - 1)
            };
          }
        }
      ]
    },
    {
      sectionTitle: 'Secure Business',
      shouldShowSection: formFields => {
        const value = getFieldValue(addProductVulcan, formFields);
        return value && value.includes(vulTSB);
      },
      rows: [
        {
          label: termLabel,
          description: GET_FIELD_VALUE,
          checkForKey: tsbTerm
        },
        {
          label: planLabel,
          description: GET_FIELD_VALUE,
          checkForKey: secureBusinessPlan,
          filterKeySubstringNegativeValues: ['oneTimeCharges']
        },
        {
          label: includedLabel,
          listSelectedValuesForEquipment: {
            basedOnKey: secureBusinessPlan,
            map: includedEquipmentValuesMap
          }
        },
        {
          label: additionalEquipmentsOneTimeLabel,
          listSelectedValuesForEquipment: {
            basedOnKey: secureBusinessPlan,
            map: additionalEquipmentValuesMap,
            filterKeysBySubstringNegative: [
              'easyThreeYear',
              'easyFiveYear',
              'businessActivityAnalytics',
              'temperatureMonitoringFiveDollarVulcan',
              'temperatureMonitoringTenDollarVulcan',
              'videoServiceCharge',
              'deterrenceAI',
              'enterpriseGroupFeature',
              'guardResponseWLN',
              'guardResponseWLNMonitor'
            ],
            sfdcDescriptionKeys: [
              'fivePortPoeSwitchVulcan',
              'fivePortPoeSwitchPaidVulcan'
            ]
          }
        },
        {
          label: additionalEquipmentsMonthlyRecuringLabel,
          listSelectedValuesForEquipment: {
            basedOnKey: secureBusinessPlan,
            map: additionalEquipmentValuesMap,
            filterKeysBySubstring: [
              'businessActivityAnalytics',
              'temperatureMonitoringFiveDollarVulcan',
              'temperatureMonitoringTenDollarVulcan',
              'videoServiceCharge',
              'deterrenceAI',
              'enterpriseGroupFeature',
              'guardResponseWLN',
              'guardResponseWLNMonitor'
            ]
          }
        },
        {
          label: additionalEquipmentsThreeYearLabel,
          listSelectedValuesForEquipment: {
            basedOnKey: secureBusinessPlan,
            map: additionalEquipmentValuesMap,
            filterKeysBySubstring: 'easyThreeYear'
          }
        },
        {
          label: additionalEquipmentsFiveYearLabel,
          listSelectedValuesForEquipment: {
            basedOnKey: secureBusinessPlan,
            map: additionalEquipmentValuesMap,
            filterKeysBySubstring: 'easyFiveYear'
          }
        },
        {
          label: 'Existing Equipment',
          tsb15TakeoverCharges: 'existingEquipment',
          valueForCheck: yes,
          sectionKeys: [existingEquipmentVulcan]
        },
        {
          label: addOnTakeoverEquipmentOneTimePayment,
          tsb15TakeoverCharges: 'oneTime',
          valueForCheck: yes,
          sectionKeys: tsb15SectionPriceKeys
        },
        {
          label: addOnTakeoverEquipmentThreeYear,
          tsb15TakeoverCharges: 'threeYearEasyPayment',
          valueForCheck: yes,
          sectionKeys: tsb15SectionPriceKeys
        },
        {
          label: addOnTakeoverEquipmentFiveYear,
          tsb15TakeoverCharges: 'fiveYearEasyPayment',
          valueForCheck: yes,
          sectionKeys: tsb15SectionPriceKeys
        },
        {
          label: installationTSBLabel,
          description: installationFee,
          checkForKey: fieldInstallationFeeAmount,
          filterKeySubstringNegativeValues: [
            'fiveYearEasyPaymentCharges',
            'qty',
            'threeYearEasyPaymentCharges'
          ]
        },
        {
          label: offersLabel,
          listSelectedOptionsForKey: secureBusinessOffersVulcan,
          getCustomLabel: formField => {
            const updatedFormField = cloneDeep(formField);

            if (
              updatedFormField[secureBusinessOffersVulcan] &&
              updatedFormField[secureBusinessOffersVulcan].options
            ) {
              const field = updatedFormField[secureBusinessOffersVulcan];
              const valueArray = Array.isArray(field.value) ? field.value : [];
              const availableOptions = field.options.map(opt => ({
                label: opt.fields.label,
                value: opt.fields.value,
                oneTimePrice:
                  opt.fields.oneTimePrice !== undefined
                    ? opt.fields.oneTimePrice.toString()
                    : ''
              }));

              updatedFormField[
                secureBusinessOffersVulcan
              ].options = updatedFormField[
                secureBusinessOffersVulcan
              ].options.map(option => ({
                ...option,
                fields: {
                  ...option.fields,
                  value: option.fields.label
                }
              }));

              updatedFormField[
                secureBusinessOffersVulcan
              ].value = valueArray.map(selectedValue => {
                let matchedOption = availableOptions.find(
                  opt =>
                    opt.label.trim().toLowerCase() ===
                      selectedValue.trim().toLowerCase() ||
                    opt.value.trim().toLowerCase() ===
                      selectedValue.trim().toLowerCase()
                );

                if (!matchedOption) {
                  const numericValue = selectedValue.replace(/[^0-9]/g, '');
                  matchedOption = availableOptions.find(
                    opt =>
                      opt.oneTimePrice &&
                      opt.oneTimePrice.replace(/[^0-9]/g, '') === numericValue
                  );
                }

                return matchedOption ? matchedOption.label : selectedValue;
              });
            }

            return updatedFormField[secureBusinessOffersVulcan];
          },
          addAdditonalInfoIntoValue: (isAlternative, isTsbData) => {
            const shouldShowSection = formFields =>
              getFieldValue(isCouponBasedDiscountTSBField, formFields) === yes;

            if (shouldShowSection) {
              const summaryDetails = getSummaryDetailsForFieldWithProductCatalog(
                isTsbData
              );

              if (summaryDetails && summaryDetails.length > 0) {
                const productCatalogData = [];
                summaryDetails.forEach(item => {
                  productCatalogData.push({
                    description: getOfferDescription(
                      item,
                      locale,
                      isAlternative
                    ),
                    oneTimeCharges: item.oneTimeCharges,
                    monthlyCharges: item.monthlyCharges,
                    threeYearEasyPaymentCharges:
                      item.threeYearEasyPaymentCharges,
                    fiveYearEasyPaymentCharges: item.fiveYearEasyPaymentCharges
                  });
                });
                return productCatalogData;
              }
            }
            return null;
          }
        }
      ]
    },
    {
      sectionTitle: 'Mobility',
      shouldShowSection: formFields => {
        const value = getFieldValue(addProductVulcan, formFields);
        return value && value.includes(vulMobility);
      },
      rows: [
        {
          label: 'Mobility Monthly Charge',
          checkForKey: mobilityMonthlyCharge
        },
        {
          label: 'Mobility One Time Charge',
          checkForKey: mobilityOneTimeCharge
        }
      ]
    },
    {
      sectionTitle: vulBusinessOptikTV,
      shouldShowSection: formFields => {
        const value = getFieldValue(addProductVulcan, formFields);
        return value && value.includes(vulBusinessOptikTV);
      },
      rows: [
        {
          label: 'Business Optik TV Table',
          listSelectedOptionsForBusinessOptikTv: 'businessOptikTvTableData'
        }
      ],
      isFlattenedRows: true
    },
    {
      sectionTitle: 'TELUS Internet Backup',
      shouldShowSection: formFields => {
        const value = getFieldValue(addProductVulcan, formFields);
        return value && value.includes(vulInternetBackup);
      },
      rows: [
        {
          label: termLabel,
          description: GET_FIELD_VALUE,
          checkForKey: termVulcan,
          filterKeySubstringNegativeValues: [
            'monthlyCharges',
            'fiveYearEasyPaymentCharges',
            'qty',
            'threeYearEasyPaymentCharges',
            'oneTimeCharges'
          ]
        },
        {
          label: vulInternetBackup,
          description: '',
          checkForKey: addProductVulcan,
          checkForOption: vulInternetBackup
        },
        {
          label: offersLabel,
          listSelectedOptionsForKey: fieldNameOfferIBVulcan
        }
      ]
    },
    {
      sectionTitle: 'Fibre Optic Drop',
      shouldShowSection: formFields => {
        const value = getFieldValue(addProductVulcan, formFields);
        return value && value.includes(vulFibreOpticDrop);
      },
      rows: [
        {
          label: vulFibreOpticDrop,
          description: '',
          checkForKey: addProductVulcan,
          checkForOption: vulFibreOpticDrop
        }
      ]
    },
    {
      sectionTitle: 'Coupon Based Discounts',
      shouldShowSection: formFields => {
        const value = getFieldValue(isCouponBasedDiscountField, formFields);
        return value === yes;
      },
      rows: [
        {
          label: 'redeemOfferData',
          listSelectedOptionsCouponCode: 'redeemOfferData'
        }
      ]
    }
  ];
};

export default getSummaryConfig;
